import apiService from './apiService';

/**
 * Setup of energy sites and meters. Administrators only; every method returns the ServiceResponse
 * body so callers check `success` before `data`.
 */
export default class EnergyAdminApiService {

    async getSites (projectId) {
        const response = await apiService.getData(`api/energy/admin/locations/${projectId}/sites`);
        return response.data;
    }

    async createSite (projectId, site) {
        const response = await apiService.postData(`api/energy/admin/locations/${projectId}/sites`, site);
        return response.data;
    }

    async updateSite (siteId, site) {
        const response = await apiService.putData(`api/energy/admin/sites/${siteId}`, site);
        return response.data;
    }

    async deleteSite (siteId) {
        const response = await apiService.deleteData(`api/energy/admin/sites/${siteId}`);
        return response.data;
    }

    async getMeters (siteId) {
        const response = await apiService.getData(`api/energy/admin/sites/${siteId}/meters`);
        return response.data;
    }

    async createMeter (siteId, meter) {
        const response = await apiService.postData(`api/energy/admin/sites/${siteId}/meters`, meter);
        return response.data;
    }

    async updateMeter (meterId, meter) {
        const response = await apiService.putData(`api/energy/admin/meters/${meterId}`, meter);
        return response.data;
    }

    async deleteMeter (meterId) {
        const response = await apiService.deleteData(`api/energy/admin/meters/${meterId}`);
        return response.data;
    }

    async getUtilities () {
        const response = await apiService.getData('api/energy/admin/utilities');
        return response.data;
    }
}
